// extracted by mini-css-extract-plugin
module.exports = {"grid":"QuickStartVideos_grid__Adtdc","fontWrapper":"QuickStartVideos_fontWrapper__2TjIT","modal":"QuickStartVideos_modal__1zjVa"};